
// Export the clientType value (useContext)
export const GetClientType = () => {
    if ( navigator.userAgent == "edex_plugin_local" ) {
        return '3dmax';
    }
    if( navigator.userAgent == "edex_plugin_local|unreal"){
        return 'unreal_engine';
    }
    return 'revit';
};

// Export other constants
let license_server = process.env.REACT_APP_LICENSE_SERVER_URL;
let purchase_url = process.env.REACT_APP_PURCHASE_URL;
let renew_url = process.env.REACT_APP_RENEW_URL;

let user_agent = navigator.userAgent.split("|");
let is_global = false;

if (user_agent[0] === process.env.REACT_APP_GLOBAL_USER_AGENT) {
    purchase_url = process.env.REACT_APP_GLOBAL_PURCHASE_URL;
    license_server = process.env.REACT_APP_GLOBAL_LICENSE_SERVER;
    renew_url = process.env.REACT_APP_GLOBAL_RENEW_URL;
    is_global = true;
}

export const IS_GLOBAL = is_global;
export const LICENSE_SERVER = license_server;
export const API_URL = process.env.REACT_APP_API_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN || "";
export const HELP_URL = process.env.REACT_APP_HELP_URL || "";
export const RULES_URL = process.env.REACT_APP_RULES_URL || "";
export const EDEX_RENEW_URL = renew_url || "";
export const TELEGRAM_CHANEL_URL = process.env.REACT_APP_TELEGRAM_CHANNEL_URL || "";
export const SYSTEM_INFO = "";
export const MACHIN_ID = "";
export const API_LATEST_VERSION = API_URL;
